import ProductActionNotifyMe from '@moncler/components/product/ProductActionNotifyMe';
import React, { useEffect, useMemo, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
const SizeSelectorModalItem = (props) => {
    var _a;
    const { t } = useTranslation();
    const optionRef = useRef();
    const currentColor = useMemo(() => {
        var _a, _b;
        return (_b = (_a = props.product) === null || _a === void 0 ? void 0 : _a.variationAttributes.find((p) => p.attributeId === 'color')) === null || _b === void 0 ? void 0 : _b.values.find((c) => c.selected === true);
    }, [props.product]);
    const onClickHandler = (e) => {
        const HTMLtarget = e.target;
        if (!HTMLtarget.closest('.right-side') && !HTMLtarget.closest('#notifyme')) {
            props.onSelect(props.selectorItem);
        }
    };
    useEffect(() => {
        if (props.focusedOption === props.index) {
            setTimeout(() => {
                optionRef.current.focus();
            }, 50);
        }
    }, [props.focusedOption]);
    return (React.createElement("li", { ref: optionRef, className: classNames('size-selector-line', { disabled: props.disabled }), role: "option", "aria-selected": props.selected, onClick: onClickHandler, onKeyDown: (e) => {
            if (e.key == 'Enter') {
                e.preventDefault();
                onClickHandler(e);
            }
            else if (e.key == 'Escape') {
                e.preventDefault();
                props.toggleModal();
                setTimeout(() => {
                    var _a;
                    (_a = document.querySelector('#size-combobox')) === null || _a === void 0 ? void 0 : _a.focus();
                }, 50);
            }
            else if (e.key == 'Tab') {
                props.toggleModal();
            }
            else if (e.key == 'ArrowUp') {
                e.preventDefault();
                props.focusOption('prev');
            }
            else if (e.key == 'ArrowDown') {
                e.preventDefault();
                props.focusOption('next');
            }
        }, tabIndex: 0 },
        React.createElement("div", { className: "left-side" },
            React.createElement("div", { className: classNames('selector-size-item', props.disabled && 'disabled', props.selected && 'selected') },
                React.createElement("span", { className: "selector-size-item__label" },
                    React.createElement("span", { className: classNames('selector-size-item__label-text', props.extraLabel && 'with-extra-label') }, props.selectorItem.displayValue),
                    props.extraLabel,
                    React.createElement("span", { className: "visually-hidden" }, props.disabled ? t('label.outofstocksize') + '-' + t('label.notifyme') : '')))),
        React.createElement("div", { className: "right-side selector-size-item-notify-me", "aria-hidden": true, tabIndex: -1 }, props.showNotifyMe && !((_a = props.selectorItem) === null || _a === void 0 ? void 0 : _a.selectable) && (React.createElement(ProductActionNotifyMe, { onOpenModal: () => props.onNotifyOpen(true), onCloseModal: () => props.onNotifyOpen(false), product: props.product, color: currentColor, size: props.selectorItem, from: "pdp", noModifiers: true, customClasses: ['button--link', 'button--link-button'], icon: "bell", tabIndex: -1 })))));
};
export default SizeSelectorModalItem;
